import styled from '@emotion/styled';

export const TagWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 16px;

  li {
    padding: 8px;
    list-style: none;
    color: var(--purple-branding);
    background: #f6e8fd;
    border-radius: 80px;
    margin-right: 16px;
  }
`;

export const Title = styled.div`
  div:first-of-type {
    color: #a19fa9;
    font-size: 12px;
    margin-bottom: 4px;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 0;
    font-weight: 600;
    font-size: 20px;
    color: #444052;
    margin-bottom: 16px;
    transition: all 0.2s ease;

    &:hover {
      opacity: 0.7;
    }
  }
`;
